import { render, staticRenderFns } from "./tiandi.vue?vue&type=template&id=041b5bc8&scoped=true&"
import script from "./tiandi.vue?vue&type=script&lang=js&"
export * from "./tiandi.vue?vue&type=script&lang=js&"
import style0 from "./tiandi.vue?vue&type=style&index=0&id=041b5bc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b5bc8",
  null
  
)

export default component.exports